<template>
  <div>
    <facit-header></facit-header>
      <div class = "profile-div col-12">
        <h5 class="mt-3 mb-3"> Device Management </h5>
        <br><br>
        <b-table  striped hover
                  show-empty
                  empty-text="There are no devices to show"
                  :fields="fields"
                  :items="devices"
                  :current-page="currentPage"
                  :per-page="perPage">
          <template slot="link" slot-scope="data">
            <i class="mdi mdi-delete red-icon" @click="deleteDevices(data.item.id)" title="Delete">
              <v-icon name="trash-2" base-class="icon-width" @click="deleteDevices(data.item.id)">
              </v-icon>
            </i>
            <i class="mdi mdi-edit red-icon" @click="getDetail(data.item.id)" title="Edit">
              <v-icon name="edit-2" base-class="icon-width" @click="getDetail(data.item.id)">
              </v-icon>
            </i>
          </template>
          <template slot="status" slot-scope="data">
            <label class="switch">
            <input type="checkbox"
                   v-model="data.value"
                   @change="statusUpdate(data.item.id,data.value)">
            <span class="slider round"></span>
          </label>
          </template>
        </b-table>
        <b-pagination align="right"
                      :total-rows="totalRows"
                      :per-page="perPage"
                      v-model="currentPage"
                      class="my-0" />

                      <b-modal v-model="userSettingsModal" hide-footer title="Edit Device">
                        <b-form @submit.prevent="updateDevices('formRegistration')"
                                class="ml-4 mr-4 mb-4"
                                data-vv-scope="formRegistration">
                          <b-form-group id="nameGroup">
                            <b-row class="my-1">
                              <b-col sm="4">
                                <label for="input-small">Description</label>
                              </b-col>
                            <b-col sm="8">
                              <b-form-input id="name"
                                          name="name"
                                          type="text"
                                          v-model="name"
                                          v-validate="'required'"
                                          :class="{'input': true,
                                                   'is-danger': errors.has('formRegistration.name') }"
                                          required
                                          placeholder="Description">
                              </b-form-input>
                              <i v-show="errors.has('formRegistration.name')" class="fa fa-warning"></i>
                              <span v-show="errors.has('formRegistration.name')"
                                    class="help is-danger">{{ errors.first('formRegistration.name') }}
                              </span>
                              </b-col>
                            </b-row>
                          </b-form-group>
                          <b-button
                            type="submit"
                            class="w-100"
                            variant="warning">Update</b-button>
                        </b-form>
                      </b-modal>
        <br><br>
      </div>

  </div>
</template>

<script>
import API from '@/api';
import FacitHeader from '@/components/header';
import Session from '@/Session';

export default {
  name: 'management',
  components: { FacitHeader },
  data() {
    return {
      currentPage: 1,
      userSettingsModal: false,
      perPage: 10,
      totalRows: 0,
      devices: null,
      userId: null,
      deviceId: null,
      name: null,
      fields: [
        {
          key: 'hostname',
          label: 'Device Name',
          sortable: true,
        },
        {
          key: 'name',
          label: 'Description',
          sortable: true,
        },
        {
          key: 'macAddress',
          label: 'MAC Address',
          sortable: true,
        },
        {
          key: 'status',
          label: 'Status',
          sortable: false,
        },
        {
          key: 'link',
          label: 'Action',
          sortable: false,
        },
      ],
    };
  },
  async created() {
    this.getDevices();
  },
  methods: {
    async getDevices() {
      const id = Session.getAccessToken().user.id;
      this.devices = await API.get(`Accounts/${id}/devices`);
      this.totalRows = this.devices.length;
    },
    async statusUpdate(deviceId, currentStatus) {
      try {
        await API.post(`Devices/${deviceId}/updateStatus`, {
          status: currentStatus,
        });
      } catch (error) {
        const message = error.response.data.error.message;
        if (message.match(/Can not activate more devices/gi)) {
          await this.$notify({
            group: 'sitewide',
            title: 'Error!',
            type: 'error',
            text: 'Can not activate more devices',
          });
          this.getDevices();
        }
      }
    },
    async deleteDevices(deviceId) {
      const userId = Session.getAccessToken().user.id;
      await API.delete(`Accounts/${userId}/devices/${deviceId}`);
      this.getDevices();
    },
    async getDetail(deviceId) {
      const userId = Session.getAccessToken().user.id;
      const deviceDetail = await API.get(`Accounts/${userId}/devices/${deviceId}`);
      this.name = deviceDetail.name;
      this.userId = userId;
      this.deviceId = deviceId;
      this.userSettingsModal = true;
    },
    async updateDevices(scope) {
      try {
        const validation = await this.$validator.validateAll(scope);
        if (validation) {
          const clientId = this.userId;
          const deviceId = this.deviceId;
          await API.put(`Accounts/${clientId}/devices/${deviceId}`, {
            name: this.name,
          });
          this.userId = null;
          this.deviceId = null;
          this.userSettingsModal = false;
          this.$notify({
            group: 'sitewide',
            title: 'Success!',
            type: 'success',
            text: 'Updated Sucessfully',
          });
          this.getDevices();
        }
      } catch (error) {
        this.userId = null;
        this.userSettingsModal = false;
        this.$notify({
          group: 'sitewide',
          title: 'Error!',
          type: 'error',
          text: 'Error while update',
        });
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 12px;
  width: 12px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #d6700a;
}

input:focus + .slider {
  box-shadow: 0 0 1px #d6700a;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 20px;
}
.switch input {
  display:none;
}
.icon-width {
  width: 20px !important;
  height: 20px !important;
}
.page-item.active .page-link {
  z-index: 1;
    color: #fff;
    background-color: #6610f2 !important;
    border-color: #6610f2 !important;
}
.profile-div {
  margin-top: 50px;
  margin-left: 50px;
  width: 95% !important;
}
.btn-warning {
  color: #fff;
  background-color: #ff8f00;
  border-color: #ff8f00;
}
</style>



// WEBPACK FOOTER //
// src/components/deviceManagement.vue